export default {
	project_name: 'Uniglobo',
	home_drills_title: 'DRILLS',
	home_events_title: 'MES ÉVÉNEMENTS',
	home_keep_watching_title: 'CONTINUER DE REGARDER',
	home_library_title: 'BIBLIOTHÈQUE',
	home_live_classes_title: 'COURS EN DIRECT',
	home_news_title: 'INFORMATIONS',
	home_online_courses_title: 'DES COURS EN LIGNE',
	home_podcasts_title: 'PODCASTS',
	home_surveys_title: 'SONDAGES',
	home_tags_title: 'SAILLANTS',
	home_trails_title: 'PISTES',
	home_webinars_title: 'WEBINAIRES',
	navbar_about_title: 'SAVOIR PLUS',
}
